import { isVisualModel } from "./visual-model.js";
export const WRITABLE_VISUAL_MODEL_TYPE = "writable-visual-model";
export function isWritableVisualModel(what) {
    return isVisualModel(what)
        && what.getTypes().includes(WRITABLE_VISUAL_MODEL_TYPE);
}
//# sourceMappingURL=writable-visual-model.js.map